import { initHeaderBundle } from './bundles/header';
import initialHonestWork from './bundles/honest_work/index';
import initialRealtorBannerButton from './bundles/realtor_offer_button/index';
import initLocationSwitcher from './bundles/user_location_switcher/index';

import './bundles/header/legacy/index.css';

initHeaderBundle();
initLocationSwitcher();
initialHonestWork();
initialRealtorBannerButton();



// WEBPACK FOOTER //
// ./src/entry-header-ts.ts